import { useNavigate } from 'react-router-dom';

export default function SupportJourneySection() {
  const navigate = useNavigate();

  return (
    <section id="suporte-premiado" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-accent-200 bg-accent-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-accent-700">
            Suporte dedicado
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Do recebimento à experiência, <span className="text-primary-600">a gente não solta a mão</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600">
            O apoio ao premiado não termina quando a premiação é entregue. Acompanhamos cada etapa para que a conquista
            vire satisfação, engajamento e prova social para a sua marca.
          </p>
        </div>

        <div className="w-full overflow-hidden rounded-3xl border border-background-200 bg-background-50">
          <img
            src="https://static.readdy.ai/image/22e92c18f0b031d861a5e53bf8e362fb/b1d1dda3b10181686e87597d2cce146d.png"
            alt="Jornada de suporte ao premiado: recebimento, entrega e utilização do prêmio"
            title="Suporte dedicado ao premiado"
            className="h-auto w-full object-cover"
          />
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-6 rounded-3xl border border-background-200 bg-background-50 px-7 py-8 md:flex-row md:px-10">
          <div className="flex items-start gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-vip-crown-line text-xl"></i>
            </span>
            <div>
              <h4 className="font-heading text-lg font-semibold text-foreground-950">
                Canal prioritário exclusivo para premiados
              </h4>
              <p className="mt-1 max-w-xl text-sm leading-relaxed text-foreground-600">
                Nada de fila no suporte comum. Quem ganha tem atendimento rápido e dedicado, do recebimento ao uso do prêmio.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => navigate('/solicitar-demo')}
            className="inline-flex h-12 shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            Fale com um especialista
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}